module.exports = __webpack_public_path__ + "assets/gov-orange-lg-logo-3bb55c.svg";